import React from "react";

const WebPages_Layout = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Layout</h1>
      <p>This is the WebPages Layout page content.</p>
    </div>
  );
};

export default WebPages_Layout;
